import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";
import LoadingOrValue from "@covertree/ui/loading/LoadingOrValue";
import { Resident } from "@graphql/api";

interface Props {
  isLoading?: boolean;
  resident?: Resident;
}

function formatPhoneNumber(phone: string | null | undefined): string {
  if (!phone) return "N/A";
  const digits = phone.replace(/\D/g, "");
  if (digits.length === 11 && digits[0] === "1") {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return phone;
}

export default function ContactDetails({ isLoading, resident }: Props) {
  return (
    <DisplayPropertiesCard
      properties={[
        {
          label: "Email",
          value: (
            <LoadingOrValue
              loading={!resident && isLoading}
              value={resident?.email ?? "N/A"}
              height={28}
              width={200}
            />
          ),
          gridSize: 6,
        },
        {
          label: "Phone Number",
          value: (
            <LoadingOrValue
              loading={!resident && isLoading}
              value={formatPhoneNumber(resident?.phoneNumber)}
              height={28}
              width={180}
            />
          ),
          gridSize: 6,
        },
      ]}
    />
  );
}
